import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme';

export default class BlogCard extends Component {
  getDogImage() {
    if (this.props.image && this.props.image.length > 6) {
      return this.props.image;
    }

    return '/images/default_dog.jpg';
  }

  render() {
    return (
      <Link to={`/blog/${this.props.slug}`} className={css(styles.card)} id={this.props.slug}>
        <div className={css(styles.card_image)}>
          <img className={css(styles.card_photo)} src={this.props.image} alt={this.props.title} />
        </div>
        <div className={css(styles.card_details)}>
          <div className={css(styles.card_meta)}>
            <div className={css(styles.card_title)}>{this.props.title}</div>
            <div className={css(styles.card_date)}>{this.props.date}</div>
            <div className={css(styles.card_summary)}>{this.props.summary}</div>
          </div>
        </div>
      </Link>
    );
  }
}

BlogCard.defaultProps = {
  status: null,
  signup: false,
  interests: [],
};

BlogCard.propTypes = {
  slug: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
};

const styles = StyleSheet.create({
  card: {
    position: 'relative',
    display: 'block',
    width: 262,
    minWidth: 262,
    padding: 18,
    margin: '0 15px 23px',
    backgroundColor: Theme.white,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.05)',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: Theme.lighter_grey,
    transition: 'all 300ms',

    ':hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 6px 11px 0 rgba(0, 0, 0, 0.05)',
    },
  },
  card_image: {
    position: 'relative',
    display: 'block',
    margin: '-18px -18px 10px',
    backgroundColor: Theme.black,

    ':before': {
      display: 'block',
      width: '100%',
      paddingTop: 'calc((200 / 280) * 100%)',
      content: '""',
    },
  },
  card_photo: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'block',
    height: '100%',
    width: '100%',
    objectFit: 'cover',
  },
  card_title: {
    marginBottom: 10,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    fontSize: 20,
    color: Theme.black,
    lineHeight: 1.4,
  },
  card_date: {
    marginBottom: 15,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    fontSize: 14,
    color: '#828282',

    [Theme.mobile_query]: {
      marginBottom: 0,
    },
  },
  card_summary: {
    marginBottom: 12.7,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    fontSize: 14,
    lineHeight: 1.4,
    color: '#021a36',
  },
});



// WEBPACK FOOTER //
// ./src/components/BlogCard/index.js